import API from './API.js'

export default class Invoice extends API {
  constructor() {
    super('invoice')
  }
}
